"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const alpinejs_1 = __importDefault(require("alpinejs"));
const aos_1 = __importDefault(require("aos"));
require("aos/dist/aos.css");
require("owl.carousel");
require("owl.carousel/dist/assets/owl.carousel.css");
require("bootstrap");
// @ts-ignore
window.Aos = aos_1.default;
aos_1.default.init();
alpinejs_1.default.data("contactForm", () => {
    return {
        data: {
            token: "",
            name: "",
            curr_email: "",
            phone: "",
            message: "",
            privacy: false,
        },
        validationErrors: {
            token: false,
            name: false,
            curr_email: false,
            phone: false,
            message: false,
            privacy: false,
        },
        controlData: {
            token: { required: false },
            name: { required: false },
            curr_email: { required: true },
            phone: { required: false },
            message: { required: true },
            privacy: { required: true },
        },
        openDatiPersonali: true,
        openFormazioneCompetenze: false,
        openDettagliCandidatura: false,
        sent: false,
        result: false,
        loading: false,
        send: "",
        submit() {
            var _a;
            console.log("submit");
            console.log(this.data);
            //this.data.token = token;
            for (let k in this.data) {
                if (typeof this.data[k] === "boolean") {
                    if (this.controlData[k].required === true) {
                        if (!this.data[k]) {
                            this.validationErrors[k] = true;
                        }
                        else {
                            this.validationErrors[k] = false;
                        }
                    }
                }
                else {
                    if ((this.data[k] === "" || this.data[k] === null) &&
                        this.controlData[k].required === true) {
                        this.validationErrors[k] = true;
                    }
                    else {
                        this.validationErrors[k] = false;
                    }
                }
            }
            if (Object.values(this.validationErrors).every((i) => i === false)) {
                console.log("ANDATO UP. this.sent: " + this.sent + "this.loading: " + this.loading);
                if (this.sent || this.loading)
                    return;
                this.$dispatch("loader:open");
                //sending form
                this.$dispatch("loader:open");
                const formData = new FormData();
                formData.append("action", "form_submit");
                for (let k in this.data) {
                    if (typeof this.data[k] === "boolean")
                        formData.append(k, this.data[k] ? "1" : "0");
                    else
                        formData.append(k, this.data[k]);
                }
                console.log("ANDATO UP 1. this.sent: " + this.sent + "this.loading: " + this.loading);
                if (this.sent || this.loading)
                    return;
                this.loading = true;
                console.log("ANDATO");
                fetch("/wp-admin/admin-ajax.php", {
                    method: "POST",
                    credentials: "same-origin",
                    body: formData,
                })
                    .then(() => {
                    var _a;
                    this.result = true;
                    this.sent = true;
                    this.loading = false;
                    console.log("ANDATO then");
                    this.$dispatch("loader:close");
                    (_a = document.getElementById("form")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
                })
                    .catch(() => {
                    this.result = false;
                    this.sent = false;
                })
                    .finally(() => {
                    console.log("ANDATO finally");
                });
            }
            else {
                this.loading = false;
                this.$dispatch("loader:close");
                this.sent = false;
                this.openDatiPersonali = true;
                this.openFormazioneCompetenze = true;
                this.openDettagliCandidatura = true;
                (_a = document.getElementById("form")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
                console.log("NON ANDATO");
            }
        },
    };
});
//window.Alpine = Alpine;
alpinejs_1.default.start();
$(".varianti").owlCarousel({
    loop: false,
    margin: 10,
    nav: false,
    responsive: {
        0: {
            items: 1,
            autoplay: true,
            nav: true,
            loop: true,
            dots: false,
        },
        600: {
            items: 2,
        },
        1000: {
            items: 4,
            margin: 30,
        },
    },
});
$(".storia").owlCarousel({
    stagePadding: 200,
    loop: false,
    margin: 10,
    items: 1,
    autoplay: true,
    lazyLoad: true,
    responsive: {
        0: {
            items: 1,
            stagePadding: 0,
        },
        600: {
            items: 1,
            stagePadding: 100,
        },
        1000: {
            items: 1,
            stagePadding: 200,
        },
        1200: {
            items: 1,
            stagePadding: 250,
        },
        1400: {
            items: 1,
            stagePadding: 250,
        },
        1600: {
            items: 1,
            stagePadding: 250,
        },
    },
});
$(".interno-prodotti").owlCarousel({
    loop: false,
    margin: 10,
    nav: true,
    navText: [
        '<img src="https://www.zoerbiger.de/template/zuegg_zoerbiger/img/freccia-sx.png">',
        '<img src="https://www.zoerbiger.de/template/zuegg_zoerbiger/img/freccia-dx.png">',
    ],
    responsive: {
        0: {
            items: 1,
            autoplay: true,
        },
        600: {
            items: 2,
        },
        1000: {
            items: 5,
            margin: 60,
        },
    },
});
$(".white-txt").click(function () {
    if ($(".bottone-collapse").hasClass("position-absolute")) {
        $(".bottone-collapse").removeClass("position-absolute");
    }
    else {
        $(".bottone-collapse").addClass("position-absolute");
    }
});
